export const all = window.clarity.translations